import localforage from 'localforage';
import { isTaskUnavailableError } from './taskSyncErrors';

export const getFailedStore = (storeName) => {
  return localforage.createInstance({
    name: `FailedOperations_${storeName}`,
  });
};

export const calculateQueueSize = (operations) => {
  try {
    return new Blob([JSON.stringify(operations)]).size;
  } catch (e) {
    return JSON.stringify(operations).length;
  }
};

const PERMANENT_BUSINESS_ERROR_PATTERNS = [
  'zadatak nije ispunjen',
  'nije u narudžbi',
  'ne postoji u organizaciji',
];

export const isPermanentBusinessError = (error, operation = null) => {
  if (!error) return false;
  if (isTaskUnavailableError(error, operation)) return true;

  const text = [
    error.message || '',
    ...(error.graphQLErrors || []).map((e) => e.message || ''),
  ]
    .join(' ')
    .toLowerCase();
  return PERMANENT_BUSINESS_ERROR_PATTERNS.some((p) => text.includes(p));
};

export const isRetriableSyncError = (error, operation = null) => {
  if (!error) return true;

  if (error.networkError || error.name === 'NetworkError') return true;

  if (error.message?.toLowerCase().includes('timeout')) return true;
  if (error.message?.toLowerCase().includes('aborted')) return true;

  if (isPermanentBusinessError(error, operation)) return false;

  const statusCode =
    error.statusCode || error.response?.status || error.networkError?.statusCode;
  if (statusCode >= 500) return true;

  if (statusCode === 429) return true;

  if (statusCode >= 400 && statusCode < 500) return false;

  if (error.graphQLErrors?.length > 0) {
    const hasNonRetriable = error.graphQLErrors.some((err) => {
      const extensions = err.extensions || {};
      if (extensions.code === 'BAD_USER_INPUT') return true;
      if (extensions.code === 'UNAUTHENTICATED') return true;
      if (extensions.code === 'FORBIDDEN') return true;
      if (extensions.code === 'CUSTOMER_BLOCKED') return true;
      if (extensions.code === 'CUSTOMER_UNBLOCKED') return true;
      return false;
    });
    if (hasNonRetriable) return false;
  }

  return true;
};

export const compareOrderItems = (items1, items2) => {
  if (!items1 || !items2) return items1 === items2;
  if (items1.length !== items2.length) return false;

  const sorted1 = [...items1].sort(
    (a, b) => (a.productID || 0) - (b.productID || 0),
  );
  const sorted2 = [...items2].sort(
    (a, b) => (a.productID || 0) - (b.productID || 0),
  );

  for (let i = 0; i < sorted1.length; i++) {
    if (
      sorted1[i].productID !== sorted2[i].productID ||
      sorted1[i].quantity !== sorted2[i].quantity ||
      sorted1[i].price !== sorted2[i].price
    ) {
      return false;
    }
  }
  return true;
};
